import httpInProgressActionTypes from '../constants/action-types';

const httpInProgressInitialState = {
  httpInProgress: false,
};

export const httpInProgressReducer = (state = httpInProgressInitialState, payload) => {
  switch (payload.type) {
    case httpInProgressActionTypes.HANDLE_HTTP_IN_PROGRESS:
      return { ...state, httpInProgress: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/http-in-progress/reducers/http-in-progress-reducer.js